import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ChatbotManagementRoutingModule } from './chatbot-management-routing.module';
import { ChatbotComponent } from './chatbot/chatbot.component';
import { FormsModule } from '@angular/forms';
import { MarkdownModule } from 'ngx-markdown';
import { ChatModalComponent } from './chat-modal/chat-modal.component';
import { AiFilterComponent } from './AI-filter/ai-filter.component';
import { FeahterIconModule } from 'src/app/core/feather-icon/feather-icon.module';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  declarations: [
    ChatbotComponent,
    ChatModalComponent,
    AiFilterComponent
  ],
  imports: [
    CommonModule,
    ChatbotManagementRoutingModule,
    FormsModule,
    MarkdownModule,
    FeahterIconModule,
    TranslateModule
  ],
  exports: [
    ChatbotComponent,
    ChatModalComponent,
    AiFilterComponent
  ]
})
export class ChatbotManagementModule { }